var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.images && _vm.product.images.length > 0)?_c('div',{staticClass:"avatar mr-3 flex-shrink-0"},[_c('img',{attrs:{"src":_vm.src}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }